import axios from "axios";

export let headers = {
  "Tenant-Access-Token": "OWFkMjgzNWI1ZDE3YzNjYjllZGM1MTA0MGRlYmZmYWI=",
  "Tenant-Access-Key": "E7uML2otOAY6uw",
};
export const BASE_URL = "https://tiltlabs-dev.confirmu.com";

export const api = axios.create({
  baseURL: BASE_URL,
  headers,
});

